module.exports = __webpack_public_path__ + "media/icons/3-26b88ff8.png";